import clsx from 'clsx'
import { Col, Grid, Row } from 'gu-ui-kit'
import TransferForm from 'modules/Forms/Agency/TransferToClient'
import formStyles from 'modules/Forms/common-form.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Agency/Transfer/transfer.module.scss'

const Transfer = () => {
  const { t } = useTranslation()

  return (
    <Grid>
      <Row justifyContent="center">
        <Col sm="auto">
          <h1 className={clsx(formStyles.formHeader, styles.header)}>
            {t('agency::transfer_form.title')}
          </h1>
          <TransferForm />
        </Col>
      </Row>
    </Grid>
  )
}

export default Transfer
